import React from 'react';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import Layout from '../../common/Layout';
import SEO from '../../common/SEO';
import { CoursesProvider } from '../../context/courses_context';
import { FilterProvider } from '../../context/filter_context';
import PosttDataaSat from './PosttDataaSat.json'
import PostOneeSat from './PostOneeSat';



const SatInnerr = () => {
    return (
        <>
            <SEO title="SAT Inner" />
            <Layout>
                <BreadcrumbOne
                    // title="Study Abroad eBooks"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Scholastic Assessment Test (SAT)"
                />
                <CoursesProvider>
                    <FilterProvider>
                        <div className="edu-course-area  bg-color-white"style={{marginBottom:"100px"}}>
                            <div className="container">
                                <div className="row g-5">
                                    
                                    
                                    <div className="edu-elements-area bg-color-white">
                                        <div className="container">
                                            <div className="row g-5">
                                                <div className="col-lg-12">
                                                    <div className="row g-5">
                                                        {
                                                            PosttDataaSat.slice(0, 12).map((item) => (
                                                                <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                                    <PostOneeSat data={item} />
                                                                </div>
                                                            ))
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <FaqIELTS /> */}

                                 

                                </div>
                            </div>
                        </div>
                    </FilterProvider>
                </CoursesProvider>

                <div >

                </div>
            </Layout>
        </>
    )
}

export default SatInnerr;